var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-layout',{attrs:{"title":"خطا 403"}},[_c('b-container',{staticClass:"mt-3",attrs:{"fluid":""}},[_c('b-alert',{attrs:{"show":""}},[_vm._v("شما به این صفحه دسترسی ندارد")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30ced5bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PageForbidden.vue
// module id = 9BvI
// module chunks = 1